var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.253,
    height: 18.575,
    viewBox: "0 0 16.253 18.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4e4e4e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.127,9.288A4.644,4.644,0,1,0,3.483,4.644,4.643,4.643,0,0,0,8.127,9.288Zm3.251,1.161h-.606a6.315,6.315,0,0,1-5.29,0H4.876A4.877,4.877,0,0,0,0,15.325v1.509a1.742,1.742,0,0,0,1.741,1.741h12.77a1.742,1.742,0,0,0,1.741-1.741V15.325A4.877,4.877,0,0,0,11.377,10.449Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeUser);
export default __webpack_public_path__ + "static/media/Icon awesome-user.66c038248044bad1978023e8d36ac8e9.svg";
export { ForwardRef as ReactComponent };